<template>
	<section class="main-content contentblocks">
		<div class="row row-header align-center white">
			<div>
				<h2 v-if="contentBlocksSubtitle" class="subtitle">
					{{ contentBlocksSubtitle }}
				</h2>
				<div v-if="contentBlocksContent" v-parse-links v-html="contentBlocksContent" />
			</div>
		</div>
		<div v-for="(block, index) in items" :key="block.ID" class="row contentblock">
			<div class="row contentblock">
				<div class="columns column6 contentblock-content" :class="index % 2 === 0 ? 'right' : 'left'">
					<h2>{{ block.header }}</h2>
					<div v-parse-links v-html="block.content" />
				</div>
				<div class="contentblock-image">
					<picture>
						<source v-if="block.imageWebp" :srcset="block.imageWebp" type="image/webp" />
						<source :srcset="block.image" />
						<img loading="lazy" :src="block.image" :alt="block.imageAlt" />
					</picture>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	items: { type: Array, default: () => [] },
	contentBlocksContent: { type: String, default: '' },
	contentBlocksSubtitle: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.contentblocks {
	background: $contentblock-background-color;
}

.background-light {
	background: $alternating-background-color;
}

.contentblock {
	margin: 40px auto;
	position: relative;
}

.row-header {
	max-width: 800px;
}

.contentblock-image {
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	width: 66%;
	z-index: 1;
}

.contentblock-content {
	background: rgb(249 246 242 / 80%);
	box-shadow: 0 18px 18px rgb(0 0 0 / 25%);
	backdrop-filter: blur(34px);
	padding: 60px 90px;
	margin: 60px auto;
	position: relative;
	z-index: 2;
}

.row:nth-child(even) .contentblock-image {
	left: 0;
	right: auto;
}

.contentblock-image img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

@media (max-width: 920px) {
	.contentblock-image {
		width: 100%;
		position: relative;
		inset: auto;
	}

	.contentblock {
		display: flex;
		flex-flow: wrap column-reverse;
	}

	.contentblock-content {
		margin: 0 auto 50px;
		padding: 50px 30px;
	}
}
</style>
